import moment from 'moment-timezone';

import deviceUses24Hour from '@/helpers/device-uses-24-hour';



/**
 * Render an "HH:mm:ss" time-of-day string for display.
 *
 * Output depends on the device's CLDR hour cycle (resolved from the raw
 * `navigator.language`, not the app's allowlisted locale set):
 *   - 24-hour locales (en-GB, de-DE, ja-JP, fr-FR, …) → "HH:mm" (always)
 *   - 12-hour locales (en-US, en-AU, en-CA, ko-KR, …) → compact form by
 *     default:
 *       exact hour → "1PM"
 *       with minutes → "1:21PM"
 *       longFormat=true → "1:00 PM" (full form, used when context needs the
 *       wider rendering — e.g. an opening-hours range like "9:00 AM – 5:00 PM")
 */
function timeOfDay(value, longFormat) {
  if (!value) {
    return null;
  }

  const m = moment(value, 'HH:mm:ss');

  if (!m.isValid()) {
    return null;
  }

  if (deviceUses24Hour()) {
    return m.format('HH:mm');
  }

  if (longFormat) {
    return m.format('h:mm A');
  }

  if (m.minute() === 0) {
    return m.format('hA');
  }

  return m.format('h:mmA');
}



export default timeOfDay;
